export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_GETFROMTOKEN_SUCCESS = 'AUTH_GETFROMTOKEN_SUCCESS';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_START = 'AUTH_START';
export const AUTH_FAIL = 'AUTH_FAIL';
export const SET_AUTH_REDIRECT_PATH = 'SET_AUTH_REDIRECT_PATH';


export const FETCH_ALUNOS = 'FETCH_ALUNOS';
export const RECEIVE_ALUNOS = 'RECEIVE_ALUNOS';
export const POST_ALUNO =  'POST_ALUNO';
export const POST_ALUNO_AFTER = 'POST_ALUNO_AFTER';
export const FETCH_ALUNO = 'FETCH_ALUNO';
export const RECEIVE_ALUNO = 'RECEIVE_ALUNO';

export const FETCH_ESTRUTURA_DISCIPLINAS = 'FETCH_ESTRUTURA_DISCIPLINAS';
export const RECEIVE_ESTRUTURA_DISCIPLINAS = 'RECEIVE_ESTRUTURA_DISCIPLINAS';

export const FETCH_CLASSES = 'FETCH_CLASSES';
export const RECEIVE_CLASSES = 'RECEIVE_CLASSES';

export const FETCH_DOF = 'FETCH_DOF';
export const RECEIVE_DOF = 'RECEIVE_DOF';

export const POST_ALUNO_PRE = 'POST_ALUNO_PRE';

export const GET_DISCOFFER_CONTENTDATES = 'GET_DISCOFFER_CONTENTDATES';
export const RECEIVE_DISCOFFER_CONTENTDATES = 'RECEIVE_DISCOFFER_CONTENTDATES';

export const FETCH_CHAMADA_DISCOFFER= 'FETCH_CHAMADA_DISCOFFER';

export const GET_FREQUENCY_CALL_PRINTING = 'GET_FREQUENCY_CALL_PRINTING';

export const GET_FREQUENCY_CALL_PRINTING_SUCCESS = 'GET_FREQUENCY_CALL_PRINTING_SUCCESS';

// Teachers
export const FETCH_TEACHERS = 'FETCH_TEACHERS';
export const RECEIVE_TEACHERS = 'RECEIVE_TEACHERS';
export const SAVE_TEACHER = 'SAVE_TEACHER';
export const SAVE_TEACHER_SUCCESS = 'SAVE_TEACHER_SUCCESS';
export const DELETE_TEACHER = 'DELETE_TEACHER';
export const DELETE_TEACHER_SUCCESS = 'DELETE_TEACHER_SUCCESS';

// Users
export const FETCH_USERS = 'FETCH_USERS';
export const RECEIVE_USERS = 'RECEIVE_USERS';
export const SAVE_USER = 'SAVE_USER';
export const SAVE_USER_SUCCESS = 'SAVE_USER_SUCCESS';
export const DELETE_USER = 'DELETE_USER';
export const DELETE_USER_SUCCESS = 'DELETE_USER_SUCCESS';

// School Authorizations
export const FETCH_SCHOOL_AUTHS = 'FETCH_SCHOOL_AUTHS';
export const RECEIVE_SCHOOL_AUTHS = 'RECEIVE_SCHOOL_AUTHS';
export const SAVE_SCHOOL_AUTH = 'SAVE_SCHOOL_AUTH';
export const SAVE_SCHOOL_AUTH_SUCCESS = 'SAVE_SCHOOL_AUTH_SUCCESS';
export const DELETE_SCHOOL_AUTH = 'DELETE_SCHOOL_AUTH';
export const DELETE_SCHOOL_AUTH_SUCCESS = 'DELETE_SCHOOL_AUTH_SUCCESS';

// Class Offers
export const FETCH_CLASS_OFFERS = 'FETCH_CLASS_OFFERS';
export const RECEIVE_CLASS_OFFERS = 'RECEIVE_CLASS_OFFERS';
export const SAVE_CLASS_OFFER = 'SAVE_CLASS_OFFER';
export const SAVE_CLASS_OFFER_SUCCESS = 'SAVE_CLASS_OFFER_SUCCESS';
export const DELETE_CLASS_OFFER = 'DELETE_CLASS_OFFER';
export const DELETE_CLASS_OFFER_SUCCESS = 'DELETE_CLASS_OFFER_SUCCESS';

// Discipline Offers
export const FETCH_DISCIPLINE_OFFERS = 'FETCH_DISCIPLINE_OFFERS';
export const RECEIVE_DISCIPLINE_OFFERS = 'RECEIVE_DISCIPLINE_OFFERS';
export const SAVE_DISCIPLINE_OFFER = 'SAVE_DISCIPLINE_OFFER';
export const SAVE_DISCIPLINE_OFFER_SUCCESS = 'SAVE_DISCIPLINE_OFFER_SUCCESS';
export const DELETE_DISCIPLINE_OFFER = 'DELETE_DISCIPLINE_OFFER';
export const DELETE_DISCIPLINE_OFFER_SUCCESS = 'DELETE_DISCIPLINE_OFFER_SUCCESS';

// Discipline Offer Student Order
export const FETCH_DOF_STUDENTS = 'FETCH_DOF_STUDENTS';
export const RECEIVE_DOF_STUDENTS = 'RECEIVE_DOF_STUDENTS';

// Installments
export const FETCH_INSTALLMENTS = 'FETCH_INSTALLMENTS';
export const RECEIVE_INSTALLMENTS = 'RECEIVE_INSTALLMENTS';
export const RECEIVE_INSTALLMENT_CONTEXT = 'RECEIVE_INSTALLMENT_CONTEXT';
export const SAVE_INSTALLMENT = 'SAVE_INSTALLMENT';
export const SAVE_INSTALLMENT_SUCCESS = 'SAVE_INSTALLMENT_SUCCESS';
export const DELETE_INSTALLMENT = 'DELETE_INSTALLMENT';
export const DELETE_INSTALLMENT_SUCCESS = 'DELETE_INSTALLMENT_SUCCESS';
export const FETCH_INSTALLMENTS_SUMMARY = 'FETCH_INSTALLMENTS_SUMMARY';
export const RECEIVE_INSTALLMENTS_SUMMARY = 'RECEIVE_INSTALLMENTS_SUMMARY';
export const FETCH_INSTALLMENTS_DETAILED = 'FETCH_INSTALLMENTS_DETAILED';
export const RECEIVE_INSTALLMENTS_DETAILED = 'RECEIVE_INSTALLMENTS_DETAILED';

// Cash Cycles
export const FETCH_CASH_CYCLES = 'FETCH_CASH_CYCLES';
export const RECEIVE_CASH_CYCLES = 'RECEIVE_CASH_CYCLES';
export const FETCH_CURRENT_CASH_CYCLE = 'FETCH_CURRENT_CASH_CYCLE';
export const RECEIVE_CURRENT_CASH_CYCLE = 'RECEIVE_CURRENT_CASH_CYCLE';
export const SAVE_CASH_CYCLE = 'SAVE_CASH_CYCLE';
export const SAVE_CASH_CYCLE_SUCCESS = 'SAVE_CASH_CYCLE_SUCCESS';
export const FETCH_CYCLE_DETAILS = 'FETCH_CYCLE_DETAILS';
export const RECEIVE_CYCLE_DETAILS = 'RECEIVE_CYCLE_DETAILS';

// Cash Transactions
export const SAVE_CASH_TRANSACTION = 'SAVE_CASH_TRANSACTION';
export const SAVE_CASH_TRANSACTION_SUCCESS = 'SAVE_CASH_TRANSACTION_SUCCESS';

// Enrollment Operations
export const ENROLLMENT_OPERATION = 'ENROLLMENT_OPERATION';
export const ENROLLMENT_OPERATION_SUCCESS = 'ENROLLMENT_OPERATION_SUCCESS';
export const ENROLLMENT_OPERATION_FAIL = 'ENROLLMENT_OPERATION_FAIL';

// Financial Dashboard
export const FETCH_FINANCIAL_DASHBOARD = 'FETCH_FINANCIAL_DASHBOARD';
export const RECEIVE_FINANCIAL_DASHBOARD = 'RECEIVE_FINANCIAL_DASHBOARD';

// Ata de Presenca
export const FETCH_ATA_PRESENCA = 'FETCH_ATA_PRESENCA';
export const RECEIVE_ATA_PRESENCA = 'RECEIVE_ATA_PRESENCA';
export const FETCH_DOF_CONTENTS = 'FETCH_DOF_CONTENTS';
export const RECEIVE_DOF_CONTENTS = 'RECEIVE_DOF_CONTENTS';
export const FETCH_BATCH_DOF_CONTENTS = 'FETCH_BATCH_DOF_CONTENTS';
export const RECEIVE_BATCH_DOF_CONTENTS = 'RECEIVE_BATCH_DOF_CONTENTS';
export const FETCH_ATA_PRESENCA_BATCH = 'FETCH_ATA_PRESENCA_BATCH';
export const RECEIVE_ATA_PRESENCA_BATCH = 'RECEIVE_ATA_PRESENCA_BATCH';
export const TOGGLE_OK_SECRETARIA = 'TOGGLE_OK_SECRETARIA';

// RBAC
export const AUTH_ROLE_LOADED = 'AUTH_ROLE_LOADED';
export const AUTH_TEACHER_LOADED = 'AUTH_TEACHER_LOADED';

// Person Documents
export const FETCH_PERSON_DOCUMENTS = 'FETCH_PERSON_DOCUMENTS';
export const RECEIVE_PERSON_DOCUMENTS = 'RECEIVE_PERSON_DOCUMENTS';
export const FETCH_DOCUMENT_TYPES = 'FETCH_DOCUMENT_TYPES';
export const RECEIVE_DOCUMENT_TYPES = 'RECEIVE_DOCUMENT_TYPES';
export const UPLOAD_PERSON_DOCUMENT = 'UPLOAD_PERSON_DOCUMENT';
export const UPLOAD_PERSON_DOCUMENT_SUCCESS = 'UPLOAD_PERSON_DOCUMENT_SUCCESS';
export const DELETE_PERSON_DOCUMENT = 'DELETE_PERSON_DOCUMENT';
export const DELETE_PERSON_DOCUMENT_SUCCESS = 'DELETE_PERSON_DOCUMENT_SUCCESS';
